/* eslint-disable */

import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Navbar from "./Navbar";
import Footer from "./Footer";

// -- css -- //
import "../css/reset.css";
import "../css/App.css";
import "../css/App.font.css";
import "../css/common.css";

import SideBox from "../pages/SideBox";
import React, { useState } from "react";
import Modal from "../pages/Modal";

/*
.
  Main 에서 element를 App 컴포넌트로 감싸져 있는 라우터는 
  Outlet 컴포넌트를 거쳐서 렌더링 됨      
*/

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  // const modalBackground = useRef();
  const modalOpenFunc = () => {
    // console.log("모달킴");
    setModalOpen(true);
  };
  const modalCloseFunc = () => {
    // console.log("모달끔");
    setModalOpen(false);
  };
  return (
    <>
      <Helmet>
        <title>레인보우브레인 | 지능형자동화 전문기업</title>
        <meta
          name="description"
          content="레인보우브레인은 지능형자동화 전문기업입니다. 비즈니스를 위한 필수 선택, 생성형 AI LLM · RAG · RPA 솔루션을 제공합니다."
        />
        <meta name="keywords" content="RPA" />
        <meta property="og:title" content="Rainbow Brain" />
        <meta
          property="og:description"
          content="Automation Anywhere RPA 솔루션 공급 및 구축 전문회사"
        />
      </Helmet>

      {/* Nav */}
      <Navbar className="nav" />

      {/* body */}
      <div className="body">
        <Outlet />
      </div>
      <div className={modalOpen ? "side_box hidden" : "side_box"}>
        <SideBox onClick={modalOpenFunc} />
      </div>
      {modalOpen && <Modal onClose={modalCloseFunc} />}

      <Footer className="footer" />
    </>
  );
}

export default App;
